import { requestNotificationPermission } from '@/config/firebase';

export class NotificationService {
  private static instance: NotificationService;
  private token: string | null = null;

  private constructor() { }

  static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  async initialize() {
    try {
      this.token = await requestNotificationPermission();
      console.log("this.token", this.token)
    } catch (error) {
      console.error('Failed to initialize notifications:', error);
    }
  }

  getToken(): string | null {
    return this.token;
  }

  public static parsePayload(payload: any) {
    console.log("payload IN NOTIFICATION SERVICE", payload)
    return {
      title: payload?.notification?.title,
      body: payload?.notification?.body
    };
  }
  
}